import { CoreIcon } from '../core-icon';
import closeSVG from '../../../src/images/icons/close.svg';

export const CloseIcon = props => {
  return <CoreIcon src={closeSVG} {...props} />;
};
